'use strict';

var cov_i23o1yinu = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\logical_plan\\logical_planCtrl.js',
      hash = 'ccb04741f6d3d9f560a1abe51eb77b0b1a12c4c0',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\logical_plan\\logical_planCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 0
        },
        end: {
          line: 295,
          column: 3
        }
      },
      '1': {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 37
        }
      },
      '2': {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 8,
          column: 3
        }
      },
      '3': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 11
        }
      },
      '4': {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 39
        }
      },
      '5': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 42
        }
      },
      '6': {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 26
        }
      },
      '7': {
        start: {
          line: 12,
          column: 17
        },
        end: {
          line: 12,
          column: 32
        }
      },
      '8': {
        start: {
          line: 13,
          column: 19
        },
        end: {
          line: 13,
          column: 35
        }
      },
      '9': {
        start: {
          line: 14,
          column: 15
        },
        end: {
          line: 14,
          column: 26
        }
      },
      '10': {
        start: {
          line: 15,
          column: 18
        },
        end: {
          line: 15,
          column: 30
        }
      },
      '11': {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 30
        }
      },
      '12': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 35
        }
      },
      '13': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 29
        }
      },
      '14': {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 33
        }
      },
      '15': {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 31
        }
      },
      '16': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 26
        }
      },
      '17': {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 27
        }
      },
      '18': {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 29,
          column: 4
        }
      },
      '19': {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 37
        }
      },
      '20': {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 36
        }
      },
      '21': {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 35,
          column: 4
        }
      },
      '22': {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 29
        }
      },
      '23': {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 24
        }
      },
      '24': {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 44,
          column: 4
        }
      },
      '25': {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 43,
          column: 7
        }
      },
      '26': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 35
        }
      },
      '27': {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 48,
          column: 4
        }
      },
      '28': {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 96
        }
      },
      '29': {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 36
        }
      },
      '30': {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 52,
          column: 4
        }
      },
      '31': {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 28
        }
      },
      '32': {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 30
        }
      },
      '33': {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 62,
          column: 4
        }
      },
      '34': {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 60,
          column: 7
        }
      },
      '35': {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 48
        }
      },
      '36': {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 73,
          column: 4
        }
      },
      '37': {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 31
        }
      },
      '38': {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 27
        }
      },
      '39': {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 72,
          column: 5
        }
      },
      '40': {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 33
        }
      },
      '41': {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 59
        }
      },
      '42': {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 70,
          column: 63
        }
      },
      '43': {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 65
        }
      },
      '44': {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 102,
          column: 4
        }
      },
      '45': {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 101,
          column: 7
        }
      },
      '46': {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 88,
          column: 7
        }
      },
      '47': {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 15
        }
      },
      '48': {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 37
        }
      },
      '49': {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 100,
          column: 9
        }
      },
      '50': {
        start: {
          line: 91,
          column: 8
        },
        end: {
          line: 91,
          column: 40
        }
      },
      '51': {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 98,
          column: 9
        }
      },
      '52': {
        start: {
          line: 93,
          column: 10
        },
        end: {
          line: 96,
          column: 13
        }
      },
      '53': {
        start: {
          line: 97,
          column: 10
        },
        end: {
          line: 97,
          column: 17
        }
      },
      '54': {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 99,
          column: 42
        }
      },
      '55': {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 131,
          column: 4
        }
      },
      '56': {
        start: {
          line: 104,
          column: 18
        },
        end: {
          line: 104,
          column: 36
        }
      },
      '57': {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 35
        }
      },
      '58': {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 27
        }
      },
      '59': {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 30
        }
      },
      '60': {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 56
        }
      },
      '61': {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 130,
          column: 7
        }
      },
      '62': {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 110,
          column: 38
        }
      },
      '63': {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 117,
          column: 7
        }
      },
      '64': {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 115,
          column: 11
        }
      },
      '65': {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 15
        }
      },
      '66': {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 124,
          column: 7
        }
      },
      '67': {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 122,
          column: 11
        }
      },
      '68': {
        start: {
          line: 123,
          column: 8
        },
        end: {
          line: 123,
          column: 15
        }
      },
      '69': {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 127,
          column: 7
        }
      },
      '70': {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 35
        }
      },
      '71': {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 128,
          column: 33
        }
      },
      '72': {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 129,
          column: 40
        }
      },
      '73': {
        start: {
          line: 132,
          column: 2
        },
        end: {
          line: 141,
          column: 4
        }
      },
      '74': {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 140,
          column: 6
        }
      },
      '75': {
        start: {
          line: 143,
          column: 2
        },
        end: {
          line: 151,
          column: 4
        }
      },
      '76': {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 150,
          column: 7
        }
      },
      '77': {
        start: {
          line: 154,
          column: 19
        },
        end: {
          line: 158,
          column: 4
        }
      },
      '78': {
        start: {
          line: 159,
          column: 2
        },
        end: {
          line: 161,
          column: 4
        }
      },
      '79': {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 160,
          column: 22
        }
      },
      '80': {
        start: {
          line: 162,
          column: 2
        },
        end: {
          line: 164,
          column: 4
        }
      },
      '81': {
        start: {
          line: 165,
          column: 2
        },
        end: {
          line: 167,
          column: 4
        }
      },
      '82': {
        start: {
          line: 170,
          column: 2
        },
        end: {
          line: 170,
          column: 23
        }
      },
      '83': {
        start: {
          line: 171,
          column: 2
        },
        end: {
          line: 247,
          column: 4
        }
      },
      '84': {
        start: {
          line: 172,
          column: 13
        },
        end: {
          line: 172,
          column: 15
        }
      },
      '85': {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 173,
          column: 26
        }
      },
      '86': {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 35
        }
      },
      '87': {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 238,
          column: 5
        }
      },
      '88': {
        start: {
          line: 177,
          column: 6
        },
        end: {
          line: 192,
          column: 8
        }
      },
      '89': {
        start: {
          line: 193,
          column: 11
        },
        end: {
          line: 238,
          column: 5
        }
      },
      '90': {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 207,
          column: 8
        }
      },
      '91': {
        start: {
          line: 208,
          column: 6
        },
        end: {
          line: 215,
          column: 7
        }
      },
      '92': {
        start: {
          line: 209,
          column: 8
        },
        end: {
          line: 214,
          column: 9
        }
      },
      '93': {
        start: {
          line: 210,
          column: 10
        },
        end: {
          line: 210,
          column: 65
        }
      },
      '94': {
        start: {
          line: 211,
          column: 10
        },
        end: {
          line: 211,
          column: 56
        }
      },
      '95': {
        start: {
          line: 212,
          column: 10
        },
        end: {
          line: 212,
          column: 69
        }
      },
      '96': {
        start: {
          line: 213,
          column: 10
        },
        end: {
          line: 213,
          column: 16
        }
      },
      '97': {
        start: {
          line: 217,
          column: 6
        },
        end: {
          line: 230,
          column: 8
        }
      },
      '98': {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 237,
          column: 7
        }
      },
      '99': {
        start: {
          line: 232,
          column: 8
        },
        end: {
          line: 236,
          column: 9
        }
      },
      '100': {
        start: {
          line: 233,
          column: 10
        },
        end: {
          line: 233,
          column: 52
        }
      },
      '101': {
        start: {
          line: 234,
          column: 10
        },
        end: {
          line: 234,
          column: 69
        }
      },
      '102': {
        start: {
          line: 235,
          column: 10
        },
        end: {
          line: 235,
          column: 16
        }
      },
      '103': {
        start: {
          line: 239,
          column: 4
        },
        end: {
          line: 239,
          column: 25
        }
      },
      '104': {
        start: {
          line: 240,
          column: 4
        },
        end: {
          line: 246,
          column: 7
        }
      },
      '105': {
        start: {
          line: 248,
          column: 2
        },
        end: {
          line: 289,
          column: 4
        }
      },
      '106': {
        start: {
          line: 249,
          column: 22
        },
        end: {
          line: 249,
          column: 31
        }
      },
      '107': {
        start: {
          line: 250,
          column: 4
        },
        end: {
          line: 288,
          column: 7
        }
      },
      '108': {
        start: {
          line: 261,
          column: 6
        },
        end: {
          line: 263,
          column: 7
        }
      },
      '109': {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 262,
          column: 15
        }
      },
      '110': {
        start: {
          line: 264,
          column: 6
        },
        end: {
          line: 264,
          column: 26
        }
      },
      '111': {
        start: {
          line: 265,
          column: 27
        },
        end: {
          line: 275,
          column: 7
        }
      },
      '112': {
        start: {
          line: 276,
          column: 6
        },
        end: {
          line: 287,
          column: 9
        }
      },
      '113': {
        start: {
          line: 277,
          column: 8
        },
        end: {
          line: 277,
          column: 30
        }
      },
      '114': {
        start: {
          line: 278,
          column: 8
        },
        end: {
          line: 285,
          column: 9
        }
      },
      '115': {
        start: {
          line: 279,
          column: 10
        },
        end: {
          line: 282,
          column: 13
        }
      },
      '116': {
        start: {
          line: 283,
          column: 10
        },
        end: {
          line: 283,
          column: 35
        }
      },
      '117': {
        start: {
          line: 284,
          column: 10
        },
        end: {
          line: 284,
          column: 17
        }
      },
      '118': {
        start: {
          line: 286,
          column: 8
        },
        end: {
          line: 286,
          column: 43
        }
      },
      '119': {
        start: {
          line: 290,
          column: 2
        },
        end: {
          line: 293,
          column: 4
        }
      },
      '120': {
        start: {
          line: 291,
          column: 4
        },
        end: {
          line: 291,
          column: 25
        }
      },
      '121': {
        start: {
          line: 292,
          column: 4
        },
        end: {
          line: 292,
          column: 36
        }
      },
      '122': {
        start: {
          line: 294,
          column: 2
        },
        end: {
          line: 294,
          column: 23
        }
      },
      '123': {
        start: {
          line: 298,
          column: 2
        },
        end: {
          line: 301,
          column: 4
        }
      },
      '124': {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 299,
          column: 24
        }
      },
      '125': {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 300,
          column: 40
        }
      },
      '126': {
        start: {
          line: 302,
          column: 2
        },
        end: {
          line: 347,
          column: 4
        }
      },
      '127': {
        start: {
          line: 305,
          column: 4
        },
        end: {
          line: 307,
          column: 5
        }
      },
      '128': {
        start: {
          line: 306,
          column: 6
        },
        end: {
          line: 306,
          column: 13
        }
      },
      '129': {
        start: {
          line: 308,
          column: 4
        },
        end: {
          line: 308,
          column: 84
        }
      },
      '130': {
        start: {
          line: 309,
          column: 4
        },
        end: {
          line: 311,
          column: 5
        }
      },
      '131': {
        start: {
          line: 310,
          column: 6
        },
        end: {
          line: 310,
          column: 13
        }
      },
      '132': {
        start: {
          line: 312,
          column: 14
        },
        end: {
          line: 324,
          column: 5
        }
      },
      '133': {
        start: {
          line: 326,
          column: 4
        },
        end: {
          line: 346,
          column: 7
        }
      },
      '134': {
        start: {
          line: 327,
          column: 6
        },
        end: {
          line: 329,
          column: 7
        }
      },
      '135': {
        start: {
          line: 328,
          column: 8
        },
        end: {
          line: 328,
          column: 15
        }
      },
      '136': {
        start: {
          line: 330,
          column: 20
        },
        end: {
          line: 330,
          column: 24
        }
      },
      '137': {
        start: {
          line: 331,
          column: 6
        },
        end: {
          line: 344,
          column: 7
        }
      },
      '138': {
        start: {
          line: 332,
          column: 23
        },
        end: {
          line: 332,
          column: 94
        }
      },
      '139': {
        start: {
          line: 333,
          column: 8
        },
        end: {
          line: 341,
          column: 9
        }
      },
      '140': {
        start: {
          line: 334,
          column: 10
        },
        end: {
          line: 334,
          column: 22
        }
      },
      '141': {
        start: {
          line: 335,
          column: 10
        },
        end: {
          line: 335,
          column: 94
        }
      },
      '142': {
        start: {
          line: 336,
          column: 15
        },
        end: {
          line: 341,
          column: 9
        }
      },
      '143': {
        start: {
          line: 337,
          column: 10
        },
        end: {
          line: 337,
          column: 22
        }
      },
      '144': {
        start: {
          line: 338,
          column: 10
        },
        end: {
          line: 338,
          column: 69
        }
      },
      '145': {
        start: {
          line: 340,
          column: 10
        },
        end: {
          line: 340,
          column: 44
        }
      },
      '146': {
        start: {
          line: 343,
          column: 8
        },
        end: {
          line: 343,
          column: 92
        }
      },
      '147': {
        start: {
          line: 345,
          column: 6
        },
        end: {
          line: 345,
          column: 26
        }
      },
      '148': {
        start: {
          line: 350,
          column: 2
        },
        end: {
          line: 354,
          column: 4
        }
      },
      '149': {
        start: {
          line: 352,
          column: 6
        },
        end: {
          line: 352,
          column: 42
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 53
          },
          end: {
            line: 4,
            column: 54
          }
        },
        loc: {
          start: {
            line: 4,
            column: 203
          },
          end: {
            line: 295,
            column: 1
          }
        },
        line: 4
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 26,
            column: 24
          },
          end: {
            line: 26,
            column: 25
          }
        },
        loc: {
          start: {
            line: 26,
            column: 36
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 26
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 40,
            column: 23
          },
          end: {
            line: 40,
            column: 24
          }
        },
        loc: {
          start: {
            line: 40,
            column: 35
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 40
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 41,
            column: 65
          },
          end: {
            line: 41,
            column: 66
          }
        },
        loc: {
          start: {
            line: 41,
            column: 73
          },
          end: {
            line: 43,
            column: 5
          }
        },
        line: 41
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 45,
            column: 25
          },
          end: {
            line: 45,
            column: 26
          }
        },
        loc: {
          start: {
            line: 45,
            column: 42
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 45
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 49,
            column: 25
          },
          end: {
            line: 49,
            column: 26
          }
        },
        loc: {
          start: {
            line: 49,
            column: 41
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 49
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 53,
            column: 28
          },
          end: {
            line: 53,
            column: 29
          }
        },
        loc: {
          start: {
            line: 53,
            column: 40
          },
          end: {
            line: 62,
            column: 3
          }
        },
        line: 53
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 63,
            column: 27
          },
          end: {
            line: 63,
            column: 28
          }
        },
        loc: {
          start: {
            line: 63,
            column: 43
          },
          end: {
            line: 73,
            column: 3
          }
        },
        line: 63
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 74,
            column: 27
          },
          end: {
            line: 74,
            column: 28
          }
        },
        loc: {
          start: {
            line: 74,
            column: 43
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 74
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 85,
            column: 7
          },
          end: {
            line: 85,
            column: 8
          }
        },
        loc: {
          start: {
            line: 85,
            column: 20
          },
          end: {
            line: 101,
            column: 5
          }
        },
        line: 85
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 90,
            column: 89
          },
          end: {
            line: 90,
            column: 90
          }
        },
        loc: {
          start: {
            line: 90,
            column: 97
          },
          end: {
            line: 100,
            column: 7
          }
        },
        line: 90
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 103,
            column: 26
          },
          end: {
            line: 103,
            column: 27
          }
        },
        loc: {
          start: {
            line: 103,
            column: 42
          },
          end: {
            line: 131,
            column: 3
          }
        },
        line: 103
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 109,
            column: 92
          },
          end: {
            line: 109,
            column: 93
          }
        },
        loc: {
          start: {
            line: 109,
            column: 100
          },
          end: {
            line: 130,
            column: 5
          }
        },
        line: 109
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 132,
            column: 24
          },
          end: {
            line: 132,
            column: 25
          }
        },
        loc: {
          start: {
            line: 132,
            column: 40
          },
          end: {
            line: 141,
            column: 3
          }
        },
        line: 132
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 143,
            column: 28
          },
          end: {
            line: 143,
            column: 29
          }
        },
        loc: {
          start: {
            line: 143,
            column: 40
          },
          end: {
            line: 151,
            column: 3
          }
        },
        line: 143
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 159,
            column: 31
          },
          end: {
            line: 159,
            column: 32
          }
        },
        loc: {
          start: {
            line: 159,
            column: 51
          },
          end: {
            line: 161,
            column: 3
          }
        },
        line: 159
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 162,
            column: 27
          },
          end: {
            line: 162,
            column: 28
          }
        },
        loc: {
          start: {
            line: 162,
            column: 74
          },
          end: {
            line: 164,
            column: 3
          }
        },
        line: 162
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 165,
            column: 25
          },
          end: {
            line: 165,
            column: 26
          }
        },
        loc: {
          start: {
            line: 165,
            column: 72
          },
          end: {
            line: 167,
            column: 3
          }
        },
        line: 165
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 171,
            column: 16
          },
          end: {
            line: 171,
            column: 17
          }
        },
        loc: {
          start: {
            line: 171,
            column: 38
          },
          end: {
            line: 247,
            column: 3
          }
        },
        line: 171
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 248,
            column: 22
          },
          end: {
            line: 248,
            column: 23
          }
        },
        loc: {
          start: {
            line: 248,
            column: 38
          },
          end: {
            line: 289,
            column: 3
          }
        },
        line: 248
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 260,
            column: 7
          },
          end: {
            line: 260,
            column: 8
          }
        },
        loc: {
          start: {
            line: 260,
            column: 20
          },
          end: {
            line: 288,
            column: 5
          }
        },
        line: 260
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 276,
            column: 97
          },
          end: {
            line: 276,
            column: 98
          }
        },
        loc: {
          start: {
            line: 276,
            column: 105
          },
          end: {
            line: 287,
            column: 7
          }
        },
        line: 276
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 290,
            column: 22
          },
          end: {
            line: 290,
            column: 23
          }
        },
        loc: {
          start: {
            line: 290,
            column: 34
          },
          end: {
            line: 293,
            column: 3
          }
        },
        line: 290
      },
      '23': {
        name: 'logical_planCtrl_edit',
        decl: {
          start: {
            line: 297,
            column: 9
          },
          end: {
            line: 297,
            column: 30
          }
        },
        loc: {
          start: {
            line: 297,
            column: 100
          },
          end: {
            line: 348,
            column: 1
          }
        },
        line: 297
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 298,
            column: 22
          },
          end: {
            line: 298,
            column: 23
          }
        },
        loc: {
          start: {
            line: 298,
            column: 34
          },
          end: {
            line: 301,
            column: 3
          }
        },
        line: 298
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 302,
            column: 24
          },
          end: {
            line: 302,
            column: 25
          }
        },
        loc: {
          start: {
            line: 302,
            column: 36
          },
          end: {
            line: 347,
            column: 3
          }
        },
        line: 302
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 326,
            column: 88
          },
          end: {
            line: 326,
            column: 89
          }
        },
        loc: {
          start: {
            line: 326,
            column: 96
          },
          end: {
            line: 346,
            column: 5
          }
        },
        line: 326
      },
      '27': {
        name: 'logical_levelCtrl',
        decl: {
          start: {
            line: 349,
            column: 9
          },
          end: {
            line: 349,
            column: 26
          }
        },
        loc: {
          start: {
            line: 349,
            column: 77
          },
          end: {
            line: 355,
            column: 1
          }
        },
        line: 349
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        }, {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        }],
        line: 6
      },
      '1': {
        loc: {
          start: {
            line: 46,
            column: 31
          },
          end: {
            line: 46,
            column: 95
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 46,
            column: 62
          },
          end: {
            line: 46,
            column: 87
          }
        }, {
          start: {
            line: 46,
            column: 90
          },
          end: {
            line: 46,
            column: 95
          }
        }],
        line: 46
      },
      '2': {
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }, {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }],
        line: 66
      },
      '3': {
        loc: {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 88,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 88,
            column: 7
          }
        }, {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 88,
            column: 7
          }
        }],
        line: 86
      },
      '4': {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        }, {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        }],
        line: 92
      },
      '5': {
        loc: {
          start: {
            line: 108,
            column: 27
          },
          end: {
            line: 108,
            column: 55
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 108,
            column: 50
          },
          end: {
            line: 108,
            column: 51
          }
        }, {
          start: {
            line: 108,
            column: 54
          },
          end: {
            line: 108,
            column: 55
          }
        }],
        line: 108
      },
      '6': {
        loc: {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 117,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 117,
            column: 7
          }
        }, {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 117,
            column: 7
          }
        }],
        line: 111
      },
      '7': {
        loc: {
          start: {
            line: 111,
            column: 10
          },
          end: {
            line: 111,
            column: 33
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 111,
            column: 10
          },
          end: {
            line: 111,
            column: 19
          }
        }, {
          start: {
            line: 111,
            column: 23
          },
          end: {
            line: 111,
            column: 33
          }
        }],
        line: 111
      },
      '8': {
        loc: {
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 124,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 124,
            column: 7
          }
        }, {
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 124,
            column: 7
          }
        }],
        line: 118
      },
      '9': {
        loc: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        }, {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        }],
        line: 125
      },
      '10': {
        loc: {
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 238,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 238,
            column: 5
          }
        }, {
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 238,
            column: 5
          }
        }],
        line: 176
      },
      '11': {
        loc: {
          start: {
            line: 193,
            column: 11
          },
          end: {
            line: 238,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 193,
            column: 11
          },
          end: {
            line: 238,
            column: 5
          }
        }, {
          start: {
            line: 193,
            column: 11
          },
          end: {
            line: 238,
            column: 5
          }
        }],
        line: 193
      },
      '12': {
        loc: {
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 214,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 214,
            column: 9
          }
        }, {
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 214,
            column: 9
          }
        }],
        line: 209
      },
      '13': {
        loc: {
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 236,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 236,
            column: 9
          }
        }, {
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 236,
            column: 9
          }
        }],
        line: 232
      },
      '14': {
        loc: {
          start: {
            line: 261,
            column: 6
          },
          end: {
            line: 263,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 261,
            column: 6
          },
          end: {
            line: 263,
            column: 7
          }
        }, {
          start: {
            line: 261,
            column: 6
          },
          end: {
            line: 263,
            column: 7
          }
        }],
        line: 261
      },
      '15': {
        loc: {
          start: {
            line: 278,
            column: 8
          },
          end: {
            line: 285,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 278,
            column: 8
          },
          end: {
            line: 285,
            column: 9
          }
        }, {
          start: {
            line: 278,
            column: 8
          },
          end: {
            line: 285,
            column: 9
          }
        }],
        line: 278
      },
      '16': {
        loc: {
          start: {
            line: 305,
            column: 4
          },
          end: {
            line: 307,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 305,
            column: 4
          },
          end: {
            line: 307,
            column: 5
          }
        }, {
          start: {
            line: 305,
            column: 4
          },
          end: {
            line: 307,
            column: 5
          }
        }],
        line: 305
      },
      '17': {
        loc: {
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 311,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 311,
            column: 5
          }
        }, {
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 311,
            column: 5
          }
        }],
        line: 309
      },
      '18': {
        loc: {
          start: {
            line: 309,
            column: 8
          },
          end: {
            line: 309,
            column: 109
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 309,
            column: 8
          },
          end: {
            line: 309,
            column: 55
          }
        }, {
          start: {
            line: 309,
            column: 59
          },
          end: {
            line: 309,
            column: 109
          }
        }],
        line: 309
      },
      '19': {
        loc: {
          start: {
            line: 318,
            column: 16
          },
          end: {
            line: 318,
            column: 116
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 318,
            column: 37
          },
          end: {
            line: 318,
            column: 61
          }
        }, {
          start: {
            line: 318,
            column: 65
          },
          end: {
            line: 318,
            column: 115
          }
        }],
        line: 318
      },
      '20': {
        loc: {
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 329,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 329,
            column: 7
          }
        }, {
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 329,
            column: 7
          }
        }],
        line: 327
      },
      '21': {
        loc: {
          start: {
            line: 331,
            column: 6
          },
          end: {
            line: 344,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 331,
            column: 6
          },
          end: {
            line: 344,
            column: 7
          }
        }, {
          start: {
            line: 331,
            column: 6
          },
          end: {
            line: 344,
            column: 7
          }
        }],
        line: 331
      },
      '22': {
        loc: {
          start: {
            line: 333,
            column: 8
          },
          end: {
            line: 341,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 333,
            column: 8
          },
          end: {
            line: 341,
            column: 9
          }
        }, {
          start: {
            line: 333,
            column: 8
          },
          end: {
            line: 341,
            column: 9
          }
        }],
        line: 333
      },
      '23': {
        loc: {
          start: {
            line: 336,
            column: 15
          },
          end: {
            line: 341,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 336,
            column: 15
          },
          end: {
            line: 341,
            column: 9
          }
        }, {
          start: {
            line: 336,
            column: 15
          },
          end: {
            line: 341,
            column: 9
          }
        }],
        line: 336
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_i23o1yinu.s[0]++;
/**
* Geographic Map - controller
*/
angular.module('app').controller('logical_planCtrl', function ($scope, SweetAlert, $deltaLogLevel, $deltaPlanLogique, FileUploader, $rootScope, $translate, $CRUDService, $otherHttpService, $uibModal, $filter) {
  cov_i23o1yinu.f[0]++;
  cov_i23o1yinu.s[1]++;

  $rootScope.processPageRight('1_5');
  cov_i23o1yinu.s[2]++;
  if ($rootScope.global_access_page_denied) {
    cov_i23o1yinu.b[0][0]++;
    cov_i23o1yinu.s[3]++;

    return;
  } else {
    cov_i23o1yinu.b[0][1]++;
  }
  cov_i23o1yinu.s[4]++;
  $deltaLogLevel.addController($scope);
  cov_i23o1yinu.s[5]++;
  $deltaPlanLogique.addController($scope);
  cov_i23o1yinu.s[6]++;
  $scope.PATH = 'Periode';
  var EXPAND = (cov_i23o1yinu.s[7]++, 'fa-angle-down');
  var COLLAPSE = (cov_i23o1yinu.s[8]++, 'fa-angle-right');
  var LEAF = (cov_i23o1yinu.s[9]++, 'fa-circle');
  var LOADING = (cov_i23o1yinu.s[10]++, 'fa-spinner');
  cov_i23o1yinu.s[11]++;
  $scope.idScope = $scope.$id;
  // Champ Personnalisé
  cov_i23o1yinu.s[12]++;
  $scope.PATHCHAMP = 'ChampsPerso';
  cov_i23o1yinu.s[13]++;
  $scope.PATHNL = 'NiveauCl';
  cov_i23o1yinu.s[14]++;
  $scope.PATHPL = 'CadreLogique';

  cov_i23o1yinu.s[15]++;
  $scope.showNiveauLog = false;
  cov_i23o1yinu.s[16]++;
  $scope.isloading = true;
  cov_i23o1yinu.s[17]++;
  $scope.listLocalite = [];

  cov_i23o1yinu.s[18]++;
  $scope.hidesubPanel = function () {
    cov_i23o1yinu.f[1]++;
    cov_i23o1yinu.s[19]++;

    $scope.show_logicallevel = false;
    cov_i23o1yinu.s[20]++;
    $scope.show_logicalplan = false;
  };

  cov_i23o1yinu.s[21]++;
  $scope.actionLabel = {
    ADD: $translate.instant('LOGICAL_PLAN.ADD'),
    LEVEL: $translate.instant('MENU.ST'),
    IMPORT: $translate.instant('LOGICAL_PLAN.IMPORT')
  };

  // Niveau logique
  cov_i23o1yinu.s[22]++;
  $scope.itemSelectedNL = {};
  cov_i23o1yinu.s[23]++;
  $scope.hideAdd = true;
  cov_i23o1yinu.s[24]++;
  $scope.canAddNewLG = function () {
    cov_i23o1yinu.f[2]++;
    cov_i23o1yinu.s[25]++;

    $otherHttpService.post($scope.PATHNL, { action: 'canAddNew' }, function (data) {
      cov_i23o1yinu.f[3]++;
      cov_i23o1yinu.s[26]++;

      $scope.hideAdd = data != 0;
    });
  };
  cov_i23o1yinu.s[27]++;
  $scope.showNiveauLog = function (value) {
    cov_i23o1yinu.f[4]++;
    cov_i23o1yinu.s[28]++;

    $scope.show_logicallevel = angular.isUndefined(value) ? (cov_i23o1yinu.b[1][0]++, !$scope.show_logicallevel) : (cov_i23o1yinu.b[1][1]++, value);
    cov_i23o1yinu.s[29]++;
    $scope.show_logicalplan = false;
  };
  cov_i23o1yinu.s[30]++;
  $scope.editNiveauLog = function (item) {
    cov_i23o1yinu.f[5]++;
    cov_i23o1yinu.s[31]++;

    item.hideEditor = false;
    cov_i23o1yinu.s[32]++;
    $scope.beginEditNL = true;
  };
  cov_i23o1yinu.s[33]++;
  $scope.editnewNiveauLog = function () {
    cov_i23o1yinu.f[6]++;
    cov_i23o1yinu.s[34]++;

    $scope.selectItemNL({
      id: 0,
      LONG_CODE_NCL: 1,
      ID_PROJET: $rootScope.currentProject.project.id,
      Niveau_CL: $scope.listData_LogLevels_bksb.length + 1,
      ETAT_INDIC_NCL: false
    });
    cov_i23o1yinu.s[35]++;
    $scope.editNiveauLog($scope.itemSelectedNL);
  };
  cov_i23o1yinu.s[36]++;
  $scope.cancelNiveauLog = function (item) {
    cov_i23o1yinu.f[7]++;
    cov_i23o1yinu.s[37]++;

    $scope.beginEditNL = false;
    cov_i23o1yinu.s[38]++;
    item.hideEditor = true;
    cov_i23o1yinu.s[39]++;
    if (item.id == 0) {
      cov_i23o1yinu.b[2][0]++;
      cov_i23o1yinu.s[40]++;

      $scope.itemSelectedNL = {};
    } else {
      cov_i23o1yinu.b[2][1]++;
      cov_i23o1yinu.s[41]++;

      item.LIBELLE_NCL = $scope.itemSelectedNL.LIBELLE_NCL;
      cov_i23o1yinu.s[42]++;
      item.LONG_CODE_NCL = $scope.itemSelectedNL.LONG_CODE_NCL;
      cov_i23o1yinu.s[43]++;
      item.ETAT_INDIC_NCL = $scope.itemSelectedNL.ETAT_INDIC_NCL;
    }
  };
  cov_i23o1yinu.s[44]++;
  $scope.deleteNiveauLog = function (item) {
    cov_i23o1yinu.f[8]++;
    cov_i23o1yinu.s[45]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),
      text: $translate.instant('LOGICAL_PLAN.CONFIRM_DELETE_LEVEL'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8', cancelButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('COMMON.YES'),
      cancelButtonText: $translate.instant('COMMON.NO'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_i23o1yinu.f[9]++;
      cov_i23o1yinu.s[46]++;

      if (!isconfirm) {
        cov_i23o1yinu.b[3][0]++;
        cov_i23o1yinu.s[47]++;

        return;
      } else {
        cov_i23o1yinu.b[3][1]++;
      }
      cov_i23o1yinu.s[48]++;
      $scope.isloadingNL_bksb = true;
      cov_i23o1yinu.s[49]++;
      $CRUDService.delet($scope.PATHNL, { action: 'supp', valeur: $filter('json')(item) }, function (data) {
        cov_i23o1yinu.f[10]++;
        cov_i23o1yinu.s[50]++;

        $scope.isloadingNL_bksb = false;
        cov_i23o1yinu.s[51]++;
        if (data < 1) {
          cov_i23o1yinu.b[4][0]++;
          cov_i23o1yinu.s[52]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
          });
          cov_i23o1yinu.s[53]++;
          return;
        } else {
          cov_i23o1yinu.b[4][1]++;
        }
        cov_i23o1yinu.s[54]++;
        $scope.loadingLogLevelData_bksb();
      });
    });
  };
  cov_i23o1yinu.s[55]++;
  $scope.validateItemNL = function (item) {
    cov_i23o1yinu.f[11]++;

    var itemp = (cov_i23o1yinu.s[56]++, angular.copy(item));
    cov_i23o1yinu.s[57]++;
    $scope.isloadingNL_bksb = true;
    cov_i23o1yinu.s[58]++;
    itemp.PLAN_ACT_NCL = 0;
    cov_i23o1yinu.s[59]++;
    itemp.ETAT_RISQUE_NCL = 0;
    cov_i23o1yinu.s[60]++;
    itemp.ETAT_INDIC_NCL = itemp.ETAT_INDIC_NCL ? (cov_i23o1yinu.b[5][0]++, 1) : (cov_i23o1yinu.b[5][1]++, 0);
    cov_i23o1yinu.s[61]++;
    $CRUDService.save($scope.PATHNL, { action: 'miseAJour', valeur: $filter('json')(itemp) }, function (data) {
      cov_i23o1yinu.f[12]++;
      cov_i23o1yinu.s[62]++;

      $scope.isloadingNL_bksb = false;
      cov_i23o1yinu.s[63]++;
      if ((cov_i23o1yinu.b[7][0]++, data == 0) || (cov_i23o1yinu.b[7][1]++, data == -2)) {
        cov_i23o1yinu.b[6][0]++;
        cov_i23o1yinu.s[64]++;

        SweetAlert.swal({
          title: $translate.instant('COMMON.ERROR_UPDATE'),
          text: $translate.instant('LOGICAL_PLAN.ERROR_UPDATE_LONG')
        });
        cov_i23o1yinu.s[65]++;
        return;
      } else {
        cov_i23o1yinu.b[6][1]++;
      }
      cov_i23o1yinu.s[66]++;
      if (data < 1) {
        cov_i23o1yinu.b[8][0]++;
        cov_i23o1yinu.s[67]++;

        SweetAlert.swal({
          title: $translate.instant('COMMON.ERROR_UPDATE'),
          text: $translate.instant('COMMON.TITLE_ERROR_ADD')
        });
        cov_i23o1yinu.s[68]++;
        return;
      } else {
        cov_i23o1yinu.b[8][1]++;
      }
      cov_i23o1yinu.s[69]++;
      if ($scope.itemSelectedNL.id == 0) {
        cov_i23o1yinu.b[9][0]++;
        cov_i23o1yinu.s[70]++;

        $scope.itemSelectedNL = {};
      } else {
        cov_i23o1yinu.b[9][1]++;
      }
      cov_i23o1yinu.s[71]++;
      $scope.beginEditNL = false;
      cov_i23o1yinu.s[72]++;
      $scope.loadingLogLevelData_bksb();
    });
  };
  cov_i23o1yinu.s[73]++;
  $scope.selectItemNL = function (item) {
    cov_i23o1yinu.f[13]++;
    cov_i23o1yinu.s[74]++;

    $scope.itemSelectedNL = {
      ID_PROJET: item.ID_PROJET,
      LIBELLE_NCL: item.LIBELLE_NCL,
      LONG_CODE_NCL: item.LONG_CODE_NCL,
      Niveau_CL: item.Niveau_CL,
      ETAT_INDIC_NCL: item.ETAT_INDIC_NCL,
      id: item.id
    };
  };

  cov_i23o1yinu.s[75]++;
  $scope.openLogStructure = function () {
    cov_i23o1yinu.f[14]++;
    cov_i23o1yinu.s[76]++;

    $uibModal.open({
      templateUrl: 'app/logical_plan/editLevel.html',
      controller: logical_levelCtrl,
      scope: $scope,
      size: 'sm',
      windowClass: 'animated fadeInLeft right-modal'
    });
  };

  // uploadfile
  var uploader = (cov_i23o1yinu.s[77]++, $scope.uploader = new FileUploader({
    url: $CRUDService.getServerAdress() + 'data/web_server.php?action=loadcsvFile&method=1&' + $CRUDService.getComplement(0, $scope.PATHNG),
    alias: 'fileCVSPlanGeo',
    removeAfterUpload: true
  }));
  cov_i23o1yinu.s[78]++;
  uploader.onAfterAddingFile = function (fileItem) {
    cov_i23o1yinu.f[15]++;
    cov_i23o1yinu.s[79]++;

    fileItem.upload();
  };
  cov_i23o1yinu.s[80]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_i23o1yinu.f[16]++;
  };
  cov_i23o1yinu.s[81]++;
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    cov_i23o1yinu.f[17]++;
  };

  // Plan Logique
  cov_i23o1yinu.s[82]++;
  $scope.planItem = {};
  cov_i23o1yinu.s[83]++;
  $scope.edit = function (item, fils) {
    cov_i23o1yinu.f[18]++;

    var el = (cov_i23o1yinu.s[84]++, {});
    cov_i23o1yinu.s[85]++;
    $scope.hidesubPanel();

    cov_i23o1yinu.s[86]++;
    $scope.show_logicalplan = true;
    cov_i23o1yinu.s[87]++;
    if (!item) {
      cov_i23o1yinu.b[10][0]++;
      cov_i23o1yinu.s[88]++;
      // Ajouter first level
      el = {
        LIBELLE_L_CL: '',
        LIBELLE_C_CL: '',
        LIBELLE_L_CL_EN: '',
        LIBELLE_C_CL_EN: '',
        CODE_CLCAFF: '',
        CODE_CLC: '',

        FIXE: '',
        NC: $scope.listData_LogLevels_bksb[0],
        CODE_CLP: null,
        CODE_NCL: $scope.listData_LogLevels_bksb[0].id,
        expanded: false,
        id: 0,
        leaf: $scope.listData_LogLevels_bksb.length == 1
      };
    } else {
        cov_i23o1yinu.b[10][1]++;
        cov_i23o1yinu.s[89]++;
        if (fils) {
          cov_i23o1yinu.b[11][0]++;
          cov_i23o1yinu.s[90]++;
          // add fils
          el = {
            LIBELLE_L_CL_EN: '',
            LIBELLE_C_CL_EN: '',
            LIBELLE_L_CL: '',
            CODE_CLCAFF: '',
            CODE_CLC: '',
            FIXE: item.CODE_CLC,
            LIBELLE_C_CL: '',
            NC: null,
            CODE_CLP: item.id,
            CODE_NCL: null,
            expanded: false,
            id: 0
          };
          cov_i23o1yinu.s[91]++;
          for (var i = 0; i < $scope.listData_LogLevels_bksb.length; i++) {
            cov_i23o1yinu.s[92]++;

            if ($scope.listData_LogLevels_bksb[i].id == item.CODE_NCL) {
              cov_i23o1yinu.b[12][0]++;
              cov_i23o1yinu.s[93]++;

              el.CODE_NCL = $scope.listData_LogLevels_bksb[i + 1].id;
              cov_i23o1yinu.s[94]++;
              el.NC = $scope.listData_LogLevels_bksb[i + 1];
              cov_i23o1yinu.s[95]++;
              el.leaf = i + 2 == $scope.listData_LogLevels_bksb.length;
              cov_i23o1yinu.s[96]++;
              break;
            } else {
              cov_i23o1yinu.b[12][1]++;
            }
          }
        } else {
          cov_i23o1yinu.b[11][1]++;
          cov_i23o1yinu.s[97]++;
          // Update
          el = {
            FIXE: '',
            LIBELLE_L_CL: item.LIBELLE_L_CL,
            LIBELLE_C_CL_EN: item.LIBELLE_C_CL_EN,
            LIBELLE_L_CL_EN: item.LIBELLE_L_CL_EN,
            LIBELLE_C_CL: item.LIBELLE_C_CL,
            CODE_CLCAFF: item.CODE_CLCAFF,
            CODE_CLC: item.CODE_CLC,

            CODE_CLP: item.CODE_CLP,
            CODE_NCL: item.CODE_NCL,
            expanded: item.expanded,
            id: item.id
          };
          cov_i23o1yinu.s[98]++;
          for (var _i = 0; _i < $scope.listData_LogLevels_bksb.length; _i++) {
            cov_i23o1yinu.s[99]++;

            if ($scope.listData_LogLevels_bksb[_i].id == item.CODE_NCL) {
              cov_i23o1yinu.b[13][0]++;
              cov_i23o1yinu.s[100]++;

              el.NC = $scope.listData_LogLevels_bksb[_i];
              cov_i23o1yinu.s[101]++;
              el.leaf = _i + 1 == $scope.listData_LogLevels_bksb.length;
              cov_i23o1yinu.s[102]++;
              break;
            } else {
              cov_i23o1yinu.b[13][1]++;
            }
          }
        }
      }cov_i23o1yinu.s[103]++;
    $scope.planItem = el;
    cov_i23o1yinu.s[104]++;
    $uibModal.open({
      templateUrl: 'app/logical_plan/edit.html',
      controller: logical_planCtrl_edit,
      scope: $scope,
      size: 'sm',
      windowClass: 'animated fadeInRight left-modal'
    });
  };
  cov_i23o1yinu.s[105]++;
  $scope.deleteItem = function (item) {
    cov_i23o1yinu.f[19]++;

    var lasticone = (cov_i23o1yinu.s[106]++, item.icon);
    cov_i23o1yinu.s[107]++;
    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),
      text: $translate.instant('LOGICAL_PLAN.CONFIRM_DELETE'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8', cancelButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('COMMON.YES'),
      cancelButtonText: $translate.instant('COMMON.NO'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_i23o1yinu.f[20]++;
      cov_i23o1yinu.s[108]++;

      if (!isconfirm) {
        cov_i23o1yinu.b[14][0]++;
        cov_i23o1yinu.s[109]++;

        return;
      } else {
        cov_i23o1yinu.b[14][1]++;
      }
      cov_i23o1yinu.s[110]++;
      item.icon = LOADING;
      var validateItem = (cov_i23o1yinu.s[111]++, {
        LIBELLE_L_CL: item.LIBELLE_L_CL,
        LIBELLE_L_CL_EN: item.LIBELLE_L_CL_EN,
        CODE_CLCAFF: item.CODE_CLCAFF,
        CODE_CLC: item.CODE_CLC,
        LIBELLE_C_CL: item.LIBELLE_C_CL,
        LIBELLE_C_CL_EN: item.LIBELLE_C_CL_EN,
        CODE_CLP: item.CODE_CLP,
        CODE_NCL: item.CODE_NCL,
        id: item.id
      });
      cov_i23o1yinu.s[112]++;
      $CRUDService.delet($scope.PATHPL, { action: 'supp', valeur: $filter('json')(validateItem) }, function (data) {
        cov_i23o1yinu.f[21]++;
        cov_i23o1yinu.s[113]++;

        item.icon = lasticone;
        cov_i23o1yinu.s[114]++;
        if (data < 0) {
          cov_i23o1yinu.b[15][0]++;
          cov_i23o1yinu.s[115]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
          });
          cov_i23o1yinu.s[116]++;
          $scope.isloading = false;
          cov_i23o1yinu.s[117]++;
          return;
        } else {
          cov_i23o1yinu.b[15][1]++;
        }
        cov_i23o1yinu.s[118]++;
        $deltaPlanLogique.removeData(item);
      });
    });
  };
  cov_i23o1yinu.s[119]++;
  $scope.cancelItem = function () {
    cov_i23o1yinu.f[22]++;
    cov_i23o1yinu.s[120]++;

    $scope.planItem = {};
    cov_i23o1yinu.s[121]++;
    $scope.show_logicalplan = false;
  };
  cov_i23o1yinu.s[122]++;
  $scope.canAddNewLG();
});

function logical_planCtrl_edit($scope, $uibModalInstance, $filter, $CRUDService, $deltaPlanLogique) {
  cov_i23o1yinu.f[23]++;
  cov_i23o1yinu.s[123]++;

  $scope.closeModal = function () {
    cov_i23o1yinu.f[24]++;
    cov_i23o1yinu.s[124]++;

    $scope.cancelItem();
    cov_i23o1yinu.s[125]++;
    $uibModalInstance.dismiss('cancel');
  };
  cov_i23o1yinu.s[126]++;
  $scope.validateItem = function () {
    cov_i23o1yinu.f[25]++;
    cov_i23o1yinu.s[127]++;

    // Verification

    if (!$scope.planItem.CODE_CLCAFF) {
      cov_i23o1yinu.b[16][0]++;
      cov_i23o1yinu.s[128]++;

      return;
    } else {
      cov_i23o1yinu.b[16][1]++;
    }
    cov_i23o1yinu.s[129]++;
    $scope.planItem.CODE_CLCAFF = $filter('uppercase')($scope.planItem.CODE_CLCAFF);
    cov_i23o1yinu.s[130]++;
    if ((cov_i23o1yinu.b[18][0]++, $scope.planItem.LIBELLE_C_CL.trim().length == 0) || (cov_i23o1yinu.b[18][1]++, $scope.planItem.LIBELLE_C_CL_EN.trim().length == 0)) {
      cov_i23o1yinu.b[17][0]++;
      cov_i23o1yinu.s[131]++;

      return;
    } else {
      cov_i23o1yinu.b[17][1]++;
    }
    var p = (cov_i23o1yinu.s[132]++, {
      id: $scope.planItem.id,
      LIBELLE_L_CL: $scope.planItem.LIBELLE_L_CL,
      LIBELLE_C_CL: $scope.planItem.LIBELLE_C_CL,
      LIBELLE_L_CL_EN: $scope.planItem.LIBELLE_L_CL_EN,
      LIBELLE_C_CL_EN: $scope.planItem.LIBELLE_C_CL_EN,
      CODE_CLC: $scope.planItem.id ? (cov_i23o1yinu.b[19][0]++, $scope.planItem.CODE_CLC) : (cov_i23o1yinu.b[19][1]++, $scope.planItem.FIXE + $scope.planItem.CODE_CLCAFF),
      CODE_CLP: $scope.planItem.CODE_CLP,
      CODE_NCL: $scope.planItem.CODE_NCL,
      CODE_CLCAFF: $scope.planItem.CODE_CLCAFF,
      leaf: $scope.planItem.leaf,
      expanded: false
    });

    cov_i23o1yinu.s[133]++;
    $CRUDService.save($scope.PATHPL, { action: 'miseAJour', valeur: $filter('json')(p) }, function (data) {
      cov_i23o1yinu.f[26]++;
      cov_i23o1yinu.s[134]++;

      if (data < 0) {
        cov_i23o1yinu.b[20][0]++;
        cov_i23o1yinu.s[135]++;

        return;
      } else {
        cov_i23o1yinu.b[20][1]++;
      }
      var oldid = (cov_i23o1yinu.s[136]++, p.id);
      cov_i23o1yinu.s[137]++;
      if (oldid == 0) {
        cov_i23o1yinu.b[21][0]++;

        var parent = (cov_i23o1yinu.s[138]++, $filter('filter')($scope.listData_pl_bksb, { id: p.CODE_CLP }, true)[0]);
        cov_i23o1yinu.s[139]++;
        if (!parent) {
          cov_i23o1yinu.b[22][0]++;
          cov_i23o1yinu.s[140]++;

          p.id = data;
          cov_i23o1yinu.s[141]++;
          $deltaPlanLogique.addData(p, $scope.planItem.NC.Niveau_CL, $scope.planItem.id != 0);
        } else {
            cov_i23o1yinu.b[22][1]++;
            cov_i23o1yinu.s[142]++;
            if (parent.isLoaded == true) {
              cov_i23o1yinu.b[23][0]++;
              cov_i23o1yinu.s[143]++;
              // Ajouter à la suite
              p.id = data;
              cov_i23o1yinu.s[144]++;
              $deltaPlanLogique.addData(p, $scope.planItem.NC.Niveau_CL);
            } else {
              cov_i23o1yinu.b[23][1]++;
              cov_i23o1yinu.s[145]++;

              $scope.loadingPLData_bksb(parent);
            }
          }
      } else {
        cov_i23o1yinu.b[21][1]++;
        cov_i23o1yinu.s[146]++;

        $deltaPlanLogique.addData(p, $scope.planItem.NC.Niveau_CL, $scope.planItem.id != 0);
      }
      cov_i23o1yinu.s[147]++;
      $scope.closeModal();
    });
  };
}
function logical_levelCtrl($scope, $uibModalInstance, $filter, $CRUDService) {
  cov_i23o1yinu.f[27]++;
  cov_i23o1yinu.s[148]++;

  $scope.LogLevel = {
    closeModal: function closeModal() {
      cov_i23o1yinu.s[149]++;

      $uibModalInstance.dismiss('cancel');
    }
  };
}